import ElementContentCustomerOrderDetail from '@/components/sections/builder/elements/body/customer/customer-order-detail/content';
import ElementSettingCustomerOrderDetail from '@/components/sections/builder/elements/body/customer/customer-order-detail/setting';
import { CustomerOrderDetailElementDataType } from '@/components/sections/builder/elements/body/customer/customer-order-detail/type';
import { BetweenHorizonalStart } from 'lucide-react';

const defaultData: CustomerOrderDetailElementDataType = {
  name: 'Order Detail',
  topPadding: 20,
  bottomPadding: 20,
};

export const ElementPreviewIcon = BetweenHorizonalStart;

const CustomerOrderDetail = {
  type: 'customer_orders_detail',
  group: 'body_customer_orders_detail',
  defaultData,
  PreviewIcon: ElementPreviewIcon,
  Element: ElementContentCustomerOrderDetail,
  Setting: ElementSettingCustomerOrderDetail,
  isImmutable: true,
  maxEntries: 1,
};

export default CustomerOrderDetail;
